import Axios from "axios";
import * as MUTATION_TYPES from "./mutation-types";
import * as GETTER_TYPES from "./getter-types";
import * as ACTION_TYPES from "./action-types";
import { SET_SNACKBAR } from "../snackbar/mutation-types";
import { GET_SNACKBAR } from "../snackbar/getter-types";
import { round } from "../../pages/nights/helpers";

export const passengersState = {
  reservationReserve: {},
  extrasAvaliable: [],
  newExtras: [],
  newPassengers: [],
  passengers: [],
  reservationCode: "",
  loading: false,
  validCode: false,
  appendIcon: "",
  boarding_passes: [],
  onlyShowPassportOption: false,
};

export const codeLength = 14;

export const passengersGetters = {
  [GETTER_TYPES.GET_RESERVATION](state) {
    return state.reservationReserve
  },
  [GETTER_TYPES.GET_PASSENGERS](state) {
    return state.reservationReserve.passengers;
  },
  [GETTER_TYPES.GET_NEW_PASSENGERS](state) {
    return state.newPassengers;
  },
  [GETTER_TYPES.GET_BOARDING_PASSES](state) {
    return state.boarding_passes;
  },
  [GETTER_TYPES.GET_RESERVATION_CODE](state) {
    return state.reservationCode;
  },
  [GETTER_TYPES.GET_LOADING](state) {
    return state.loading;
  },
  [GETTER_TYPES.GET_VALID_CODE](state) {
    return state.validCode;
  },
  [GETTER_TYPES.GET_APPEND_ICON](state) {
    return state.appendIcon;
  },
  [GETTER_TYPES.GET_AVALIABLE_EXTRAS](state) {
    return state.extrasAvaliable;
  },
  [GETTER_TYPES.GET_NEW_EXTRAS](state) {
    return state.newExtras;
  },
  [GETTER_TYPES.GET_EXTRAS_TO_ADD](state, getters) {
    return getters[GETTER_TYPES.GET_AVALIABLE_EXTRAS].filter((extraAvaliable) => 
      getters[GETTER_TYPES.GET_RESERVATION].extras.every((extraAlreadyAdded) => extraAlreadyAdded.id != extraAvaliable.id))
  },
  [GETTER_TYPES.GET_ANY_BAGS_TO_ADD]: (state, getters) => {
    let anyBagToAdd = false;

    const bagsAvaliable = state.nights.resources.bags;

    const passengers = getters[GETTER_TYPES.GET_PASSENGERS];

    if(!passengers) return [];
    
    passengers.forEach(passenger => {
      const bag = bagsAvaliable.filter(bagsAvaliable => {
        if(bagsAvaliable.included) return false;
  
        return passenger.bags.every((bagAlreadyAdded) => bagAlreadyAdded.description != bagsAvaliable.description);
      });

      if(bag.length) anyBagToAdd = true;
    
    });

    return anyBagToAdd;

  },
  [GETTER_TYPES.GET_SELECTED_EXTRA_BY_ID]: state => extraId => {
    return state.newExtras.find(({ id }) => id === extraId);
  },
  [GETTER_TYPES.GET_EXTRA_BY_ID]: state => extraId => {
    return state.extrasAvaliable.find(({ id }) => id === extraId);
  },
  [GETTER_TYPES.GET_TOTAL_PASSENGERS]: (state, getters) => {
    return getters[GETTER_TYPES.GET_PASSENGERS].length;
  },
  [GETTER_TYPES.GET_EXTRA_UNIT_PRICE]: (state, getters) => extraId => {
    const extra = getters[GETTER_TYPES.GET_EXTRA_BY_ID](extraId);
    return extra.pivot ? extra.pivot.price : extra.price;
  },
  [GETTER_TYPES.GET_EXTRA_PRICE_TIMES_QUANTITY]: (
    state,
    getters
  ) => (extra, totalPassengers) => {

    const { one_per_passenger, has_counter } = extra;
    let quantity;

    if (one_per_passenger) {
      quantity = totalPassengers;
    } else {
      quantity = has_counter ? extra.quantity : 1;
    }

    const price =
      getters[GETTER_TYPES.GET_EXTRA_UNIT_PRICE](extra.id) *
      quantity;

    return round(price);
  },
  [GETTER_TYPES.GET_TOTAL_BONUS]: (state, getters) => {
    let total = 0;

      state.newExtras.forEach(extra => {
          total += getters[GETTER_TYPES.GET_EXTRA_PRICE_TIMES_QUANTITY](extra, getters[GETTER_TYPES.GET_TOTAL_PASSENGERS]);
      });

      state.newPassengers.forEach(passenger => {
        passenger.bags.forEach(bag => {
            total += bag.price;
        });
      });

      return total;
  }
};

export const passengersMutations = {
  [MUTATION_TYPES.SET_PASSENGERS](state, payload) {
    state.passengers = [...payload];
    state.nights.passengers = [...payload];

    //TODO(sprint): fill adults, children, babies in nights
  },
  [MUTATION_TYPES.SET_AGE_TO_PASSENGER](state, payload) {
    state.passengers[payload.index] = { ...payload.passenger };
  },
  [MUTATION_TYPES.SET_BOARDING_PASSES](state, payload) {
    state.boarding_passes = payload ? [...payload] : [];
  },
  [MUTATION_TYPES.SET_RESERVATION_CODE](state, payload) {
    state.reservationCode = payload;
  },
  [MUTATION_TYPES.SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [MUTATION_TYPES.SET_VALID_CODE_TO_TRUE](state, payload) {
    state.validCode = payload;
  },
  [MUTATION_TYPES.SET_APPEND_ICON](state, payload) {
    state.appendIcon = payload;
  },
  [MUTATION_TYPES.SET_ONLY_SHOW_PASSPORT_OPTION](state, payload) {
    state.onlyShowPassportOption = payload;
  },
  [MUTATION_TYPES.SET_PASSENGERS_FILLED](state, payload) {
    // state.passengers = payload;
  },
  [MUTATION_TYPES.SET_RESERVATION](state, payload) {
    state.reservationReserve = { ...payload };
  },
  [MUTATION_TYPES.SET_RESERVATION_STATUS](state, payload) {
    state.reservationReserve.status = payload;
  },
  [MUTATION_TYPES.SET_AVALIABLE_EXTRAS](state, payload) {
    state.extrasAvaliable = [...payload];
  },
  [MUTATION_TYPES.TOGGLE_PASSENGER_BAG](state, { passengerId, bagId }) {
    const passenger = state.newPassengers.find(
      ({ id }) => id === passengerId
    );
    const bag = _.cloneDeep(
      state.nights.resources.bags.find(({ id }) => id === bagId)
    );

    const index = passenger.bags.findIndex(({ id }) => id === bagId);
    if (index === -1) {
      passenger.bags = [...passenger.bags, bag];
    } else {
      passenger.bags = [
        ...passenger.bags.slice(0, index),
        ...passenger.bags.slice(index + 1)
      ];
    }
  },
  [MUTATION_TYPES.SET_NEW_PASSENGERS](state, payload) {
    state.newPassengers = payload.map(passenger => {
      return {
        ...passenger,
        bags: []
      }
    })
  },
  [MUTATION_TYPES.TOGGLE_EXTRA](state, extraId) {
    const extra = _.cloneDeep(
      state.extrasAvaliable.find(({ id }) => id == extraId)
    );

    const index = state.newExtras.findIndex(({ id }) => id === extraId);
    if (index === -1) {
      extra.quantity = extra.one_per_passenger
        ? state.reservationReserve.passengers.length
        : 1;
      state.newExtras = [...state.newExtras, extra];
    } else {
      state.newExtras = [
        ...state.newExtras.slice(0, index),
        ...state.newExtras.slice(index + 1)
      ];
    }
  },
  [MUTATION_TYPES.SET_EXTRA_QUANTITY](state, { quantity, extraId }) {
    const extra = state.newExtras.find(({ id }) => id === extraId);
    extra.quantity = quantity;
  },

};

export const passengersActions = {
  [ACTION_TYPES.RETRIEVE_RESERVATION_RESERVE_AREA]({ commit, state, dispatch }, payload) {
    commit(MUTATION_TYPES.SET_LOADING, true);
    axios
      .get(`/api/passengers/reservation/${payload}`)
      .then(data => {
        return data.data;
      })
      .then(data => {
        dispatch(ACTION_TYPES.FETCH_AND_SET_EXTRAS, { code: data.reservation.destination.code, airlines: data.reservation.airline });

        commit(MUTATION_TYPES.SET_RESERVATION, data.reservation);
        commit(MUTATION_TYPES.SET_PASSENGERS, data.reservation.passengers);
        commit(MUTATION_TYPES.SET_NEW_PASSENGERS, data.reservation.passengers);
        commit(MUTATION_TYPES.SET_BOARDING_PASSES, data.reservation.boardings);
        commit(MUTATION_TYPES.SET_APPEND_ICON, "mdi-check-bold");
        commit(MUTATION_TYPES.SET_ONLY_SHOW_PASSPORT_OPTION, data.reservation.destination.slug === 'londres');
        commit(MUTATION_TYPES.SET_VALID_CODE_TO_TRUE);
        commit(MUTATION_TYPES.SET_LOADING, false);
        commit(MUTATION_TYPES.SET_APPEND_ICON, '');
      })
      .catch(err => {
        console.log(err);
        commit(MUTATION_TYPES.SET_LOADING, false);
        commit(SET_SNACKBAR, {
          ...store.getters.GET_SNACKBAR,
          color: "error",
          text: "No hemos encontrado la reserva",
          value: true
        });
      });
  },
  [ACTION_TYPES.SET_RESERVATION_CODE_ACTION]({ commit, dispatch }, payload) {
    if (payload == null) return;
    commit(MUTATION_TYPES.SET_RESERVATION_CODE, payload);
    payload.length == codeLength &&
      dispatch(ACTION_TYPES.RETRIEVE_RESERVATION_RESERVE_AREA, payload);
    let icon = payload == "" ? "" : "close";
    commit(MUTATION_TYPES.SET_APPEND_ICON, icon);

    return 'ok';
  },
  [ACTION_TYPES.SET_PASSENGERS_FILLED_ACTION]({ commit }, payload) {
    commit(MUTATION_TYPES.SET_LOADING, true);
    commit(MUTATION_TYPES.SET_PASSENGERS_FILLED, payload);
    const travellers = payload[0];
    axios
      .post("/api/passengers/save", {
        params: {
          passengers: JSON.stringify(
            travellers.map(passenger => {
              return {
                name: passenger.name,
                last_name: passenger.lastName,
                email: passenger.email,
                date_of_birth: passenger.date_of_birth,
                card_id_type: passenger.card_id_type,
                card_id: passenger.card_id,
                expiration_date: passenger.expiration_date,
                phone_prefix: passenger.phone_prefix,
                phone: passenger.phone,
                type: passenger.type,
                nationality: passenger.nationality
              };
            })
          ),
          code: payload[1]
        }
      })
      .then(res => {
        commit(MUTATION_TYPES.SET_LOADING, false);
        commit(SET_SNACKBAR, {
          ...store.getters.GET_SNACKBAR,
          color: "success",
          text: "¡Datos recibidos! Recuerda que tus tarjetas de embarque llegarán 24h antes de tu vuelo",
          value: true
        });
        setTimeout(() => {
          commit(MUTATION_TYPES.SET_RESERVATION_STATUS, 'data-sent');
        }, 800);
      })
      .catch(err => {
        commit(MUTATION_TYPES.SET_LOADING, false);
        commit(SET_SNACKBAR, {
          ...store.getters.GET_SNACKBAR,
          color: "error",
          text: "No hemos podido guardar la información",
          value: true
        });
      });
  },
  async [ACTION_TYPES.FETCH_AND_SET_EXTRAS]({ commit, state }, payload) {
    const { code, airlines } = { ...payload };

    const { data } = await axios.get(
      `/api/extras?destination=${code}&providers=${airlines}`
    );
    commit(MUTATION_TYPES.SET_AVALIABLE_EXTRAS, data);
  }
};
